export const LOAD_USERS = 'LOAD_USERS'
export const GET_ALL_USERS = 'GET_ALL_USERS'

export const ENROLL_USER = 'ENROLL_USER'
export const UN_ENROLL_USER = 'UN_ENROLL_USER'
